import React from 'react';
import { useTranslation } from 'react-i18next';
import SEOHead from '../components/SEOHead';
import './Privacy.css';

const PRIVACY_EMAIL = 'info@gfmstudio.com';

const Privacy = () => {
  const { i18n } = useTranslation();
  const isKa = i18n.language === 'ka';
  const lastUpdated = isKa ? '2026 წლის 23 აპრილი' : 'April 23, 2026';

  return (
    <div className="privacy-page privacy-page-reference">
      <SEOHead
        title={isKa ? 'კონფიდენციალურობის პოლიტიკა | GFM Studio' : 'Privacy Policy | GFM Studio'}
        description={
          isKa
            ? 'GFM Studio-ს ვებსაიტის, მობილური აპლიკაციებისა და ციფრული სერვისების კონფიდენციალურობის პოლიტიკა.'
            : 'Privacy policy for GFM Studio websites, mobile applications, and related digital services.'
        }
        path="/privacy"
      />
      <div className="privacy-header">
        <h1>{isKa ? 'კონფიდენციალურობის პოლიტიკა' : 'Privacy Policy'}</h1>
        <span className="privacy-header-underline" />
        <p className="privacy-meta">{isKa ? 'ბოლოს განახლდა: ' : 'Last updated: '}{lastUpdated}</p>
      </div>

      {isKa ? (
        <div className="privacy-content">
          <p className="privacy-lead">
            GFM Studio (&bdquo;ჩვენ&ldquo;, &bdquo;ჩვენი&ldquo; ან &bdquo;კომპანია&ldquo;) პატივს სცემს თქვენი
            პერსონალური მონაცემების კონფიდენციალურობას და ვალდებულია დაიცვას ისინი. ეს კონფიდენციალურობის
            პოლიტიკა განმარტავს, როგორ ვაგროვებთ, ვიყენებთ, ვინახავთ, ვამუშავებთ და ვიცავთ ინფორმაციას, როდესაც
            იყენებთ GFM Studio-ს ვებსაიტს, მობილურ აპლიკაციებსა და სხვა ციფრულ სერვისებს (ერთობლივად &ndash;
            &bdquo;სერვისები&ldquo;).
          </p>
          <p>სერვისების გამოყენებით ადასტურებთ, რომ გაეცანით და ეთანხმებით წინამდებარე პოლიტიკას.</p>

          <section>
            <h2>1. ვინ ვართ ჩვენ</h2>
            <p>
              GFM Studio არის ციფრული პროდუქტებისა და პროგრამული გადაწყვეტილებების შემქმნელი კომპანია, რომელიც
              უზრუნველყოფს ვებსაიტებს, მობილურ აპლიკაციებსა და დაკავშირებულ სერვისებს.
            </p>
            <p>კონფიდენციალურობასთან დაკავშირებულ საკითხებზე შეგიძლიათ დაგვიკავშირდეთ:</p>
            <p>
              <strong>ელფოსტა:</strong>{' '}
              <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2>2. რა ინფორმაციას ვაგროვებთ</h2>
            <p>სერვისების გამოყენებისას შესაძლოა შევაგროვოთ და დავამუშაოთ შემდეგი კატეგორიის ინფორმაცია:</p>

            <h3>ანგარიშისა და პროფილის ინფორმაცია</h3>
            <ul>
              <li>სახელი და გვარი;</li>
              <li>ელფოსტის მისამართი;</li>
              <li>ტელეფონის ნომერი;</li>
              <li>მომხმარებლის როლი ან სტატუსი;</li>
              <li>სხვა ინფორმაცია, რომელსაც თავად გვაწვდით რეგისტრაციის ან პროფილის შევსებისას.</li>
            </ul>

            <h3>თქვენ მიერ მოწოდებული ინფორმაცია</h3>
            <ul>
              <li>საკონტაქტო ფორმებით გამოგზავნილი მონაცემები;</li>
              <li>მხარდაჭერის მოთხოვნები;</li>
              <li>შეტყობინებები;</li>
              <li>დოკუმენტები, ფაილები ან სხვა კონტენტი, რომელსაც ატვირთავთ ან გვიზიარებთ.</li>
            </ul>

            <h3>მოწყობილობისა და სისტემური ინფორმაცია</h3>
            <ul>
              <li>მოწყობილობის ტიპი;</li>
              <li>ოპერაციული სისტემის ვერსია;</li>
              <li>ბრაუზერის ტიპი;</li>
              <li>აპლიკაციის ვერსია;</li>
              <li>ენის პარამეტრები;</li>
              <li>IP მისამართი;</li>
              <li>ტექნიკური და დიაგნოსტიკური ჟურნალები.</li>
            </ul>

            <h3>გამოყენების ინფორმაცია</h3>
            <ul>
              <li>სერვისებში შესრულებული მოქმედებები;</li>
              <li>გამოყენებული ფუნქციები;</li>
              <li>შესვლისა და აქტივობის დრო;</li>
              <li>შეცდომებისა და მუშაობის ანგარიშები.</li>
            </ul>

            <h3>კომუნიკაციის ინფორმაცია</h3>
            <ul>
              <li>ჩვენთან მიმოწერა;</li>
              <li>მხარდაჭერის მოთხოვნები;</li>
              <li>უკუკავშირი და შეფასებები.</li>
            </ul>

            <h3>Push შეტყობინებები</h3>
            <p>
              თუ შესაბამის ნებართვას გასცემთ, შეიძლება შევინახოთ Push Notification Token-ები, რათა
              გამოგიგზავნოთ სისტემური შეტყობინებები. მათი გამორთვა ნებისმიერ დროს შეგიძლიათ მოწყობილობის
              პარამეტრებიდან.
            </p>

            <h3>Cookie-ები და მსგავსი ტექნოლოგიები</h3>
            <p>ვებსაიტზე შესაძლოა გამოყენებული იყოს Cookie-ები და მსგავსი ტექნოლოგიები:</p>
            <ul>
              <li>ავტორიზაციის შესანარჩუნებლად;</li>
              <li>პარამეტრების დასამახსოვრებლად;</li>
              <li>უსაფრთხოების გასაუმჯობესებლად;</li>
              <li>ტრაფიკისა და გამოყენების ანალიზისთვის.</li>
            </ul>
            <p>Cookie-ების მართვა შესაძლებელია თქვენი ბრაუზერის პარამეტრებიდან.</p>
          </section>

          <section>
            <h2>3. როგორ ვიყენებთ ინფორმაციას</h2>
            <p>მონაცემებს ვიყენებთ შემდეგი მიზნებისთვის:</p>
            <ul>
              <li>სერვისების მიწოდებისა და ფუნქციონირების უზრუნველსაყოფად;</li>
              <li>მომხმარებელთა ავთენტიფიკაციისა და ავტორიზაციისთვის;</li>
              <li>ანგარიშებისა და პროფილების სამართავად;</li>
              <li>მხარდაჭერისა და მომხმარებელთა მომსახურების გასაწევად;</li>
              <li>უსაფრთხოების მონიტორინგისა და თაღლითობის პრევენციისთვის;</li>
              <li>სისტემური შეტყობინებებისა და მნიშვნელოვანი განახლებების გასაგზავნად;</li>
              <li>სერვისების ხარისხის, სტაბილურობისა და წარმადობის გასაუმჯობესებლად;</li>
              <li>სამართლებრივი ვალდებულებების შესასრულებლად;</li>
              <li>ანალიტიკური და სტატისტიკური მიზნებისთვის.</li>
            </ul>
          </section>

          <section>
            <h2>4. სამართლებრივი საფუძვლები</h2>
            <p>
              სადაც მოქმედებს GDPR ან სხვა შესაბამისი კანონმდებლობა, მონაცემთა დამუშავება ემყარება ერთ ან
              რამდენიმე სამართლებრივ საფუძველს:
            </p>
            <ul>
              <li>
                <strong>ხელშეკრულების შესრულება</strong> &mdash; თქვენთვის მოთხოვნილი სერვისების
                უზრუნველსაყოფად;
              </li>
              <li>
                <strong>კანონიერი ინტერესი</strong> &mdash; სერვისების გაუმჯობესებისა და უსაფრთხოების
                უზრუნველსაყოფად;
              </li>
              <li>
                <strong>სამართლებრივი ვალდებულება</strong> &mdash; კანონით გათვალისწინებული მოთხოვნების
                შესასრულებლად;
              </li>
              <li>
                <strong>თანხმობა</strong> &mdash; როდესაც კონკრეტული დამუშავებისთვის თქვენი თანხმობაა
                საჭირო.
              </li>
            </ul>
            <p>
              თქვენ გაქვთ უფლება ნებისმიერ დროს გააუქმოთ თანხმობა იმ შემთხვევებში, როდესაც მონაცემთა
              დამუშავება მასზეა დაფუძნებული.
            </p>
          </section>

          <section>
            <h2>5. როგორ ვუზიარებთ ინფორმაციას</h2>
            <p>ჩვენ არ ვყიდით, არ ვაქირავებთ და არ ვავაჭრებთ თქვენს პერსონალურ მონაცემებს.</p>
            <p>მონაცემები შესაძლოა გავუზიაროთ:</p>

            <h3>სერვისის მომწოდებლებს</h3>
            <p>მესამე მხარეებს, რომლებიც გვეხმარებიან:</p>
            <ul>
              <li>ჰოსტინგში;</li>
              <li>მონაცემთა შენახვაში;</li>
              <li>ელფოსტის მომსახურებაში;</li>
              <li>ანალიტიკაში;</li>
              <li>უსაფრთხოებისა და მონიტორინგის სისტემებში.</li>
            </ul>

            <h3>პლატფორმის პროვაიდერებს</h3>
            <p>
              თუ იყენებთ ჩვენს მობილურ აპლიკაციას, Apple და Google შესაძლოა ამუშავებდნენ გარკვეულ
              მონაცემებს საკუთარი კონფიდენციალურობის პოლიტიკის შესაბამისად.
            </p>

            <h3>სამართლებრივი მოთხოვნების შემთხვევაში</h3>
            <p>
              როდესაც ამას მოითხოვს კანონი, სასამართლო გადაწყვეტილება, სახელმწიფო ორგანო ან უსაფრთხოების
              ინტერესი.
            </p>

            <h3>ბიზნეს ტრანზაქციების შემთხვევაში</h3>
            <p>
              შერწყმის, რეორგანიზაციის, აქტივების გაყიდვის ან სხვა ბიზნეს ოპერაციების დროს.
            </p>
          </section>

          <section>
            <h2>6. საერთაშორისო გადაცემები</h2>
            <p>
              თქვენი ინფორმაცია შესაძლოა დამუშავდეს და შეინახოს საქართველოში, ევროპის ეკონომიკურ ზონაში,
              ამერიკის შეერთებულ შტატებში ან სხვა ქვეყნებში, სადაც ჩვენ ან ჩვენი სერვისის მომწოდებლები
              ოპერირებენ.
            </p>
            <p>
              საჭიროების შემთხვევაში ვიყენებთ მონაცემთა დაცვის შესაბამის სამართლებრივ მექანიზმებს, მათ
              შორის სტანდარტულ სახელშეკრულებო პირობებს (Standard Contractual Clauses).
            </p>
          </section>

          <section>
            <h2>7. მონაცემების შენახვის ვადა</h2>
            <p>პერსონალურ მონაცემებს ვინახავთ მხოლოდ იმ პერიოდის განმავლობაში, რომელიც აუცილებელია:</p>
            <ul>
              <li>სერვისების მიწოდებისთვის;</li>
              <li>სამართლებრივი ვალდებულებების შესასრულებლად;</li>
              <li>ბუღალტრული და საგადასახადო მოთხოვნების დასაკმაყოფილებლად;</li>
              <li>დავების გადასაწყვეტად;</li>
              <li>უსაფრთხოების უზრუნველყოფისთვის.</li>
            </ul>
            <p>როდესაც მონაცემები აღარ არის საჭირო, ისინი იშლება ან ანონიმიზდება.</p>
          </section>

          <section>
            <h2>8. უსაფრთხოება</h2>
            <p>ჩვენ ვიყენებთ შესაბამის ტექნიკურ და ორგანიზაციულ ზომებს თქვენი მონაცემების დასაცავად, მათ შორის:</p>
            <ul>
              <li>დაშიფვრას შესაბამის შემთხვევებში;</li>
              <li>წვდომის კონტროლს;</li>
              <li>სისტემების მონიტორინგს;</li>
              <li>უსაფრთხოების რეგულარულ შემოწმებას.</li>
            </ul>
            <p>
              მიუხედავად ამისა, ინტერნეტით მონაცემთა გადაცემის ან ელექტრონული შენახვის არცერთი მეთოდი არ
              არის სრულად უსაფრთხო და 100%-იანი დაცვის გარანტიას ვერ ვიძლევით.
            </p>
          </section>

          <section>
            <h2>9. თქვენი უფლებები</h2>
            <p>მოქმედი კანონმდებლობის ფარგლებში შესაძლოა გქონდეთ უფლება:</p>
            <ul>
              <li>მოითხოვოთ თქვენს მონაცემებზე წვდომა;</li>
              <li>მოითხოვოთ მონაცემების გასწორება;</li>
              <li>მოითხოვოთ მონაცემების წაშლა;</li>
              <li>შეზღუდოთ მონაცემთა დამუშავება;</li>
              <li>გააპროტესტოთ გარკვეული ტიპის დამუშავება;</li>
              <li>მოითხოვოთ მონაცემთა პორტაბელურობა;</li>
              <li>გააუქმოთ ადრე გაცემული თანხმობა.</li>
            </ul>
            <p>
              ამ უფლებების გამოსაყენებლად დაგვიკავშირდით:{' '}
              <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2>10. ბავშვთა კონფიდენციალურობა</h2>
            <p>
              ჩვენი სერვისები არ არის განკუთვნილი 16 წლამდე ასაკის ბავშვებისთვის (ან თქვენი იურისდიქციის
              შესაბამისი მინიმალური ასაკისთვის).
            </p>
            <p>
              ჩვენ შეგნებულად არ ვაგროვებთ არასრულწლოვანთა პერსონალურ მონაცემებს. თუ აღმოაჩენთ, რომ ბავშვმა
              მოგვაწოდა პერსონალური ინფორმაცია, გთხოვთ დაუყოვნებლივ დაგვიკავშირდეთ.
            </p>
          </section>

          <section>
            <h2>11. მესამე მხარის ბმულები</h2>
            <p>
              ჩვენი სერვისები შეიძლება შეიცავდეს ბმულებს მესამე მხარის ვებსაიტებზე ან სერვისებზე.
            </p>
            <p>
              ჩვენ არ ვართ პასუხისმგებელი ამ რესურსების კონფიდენციალურობის პრაქტიკაზე და გირჩევთ გაეცნოთ
              მათ შესაბამის პოლიტიკებს.
            </p>
          </section>

          <section>
            <h2>12. ანალიტიკა</h2>
            <p>
              შესაძლოა გამოვიყენოთ ანალიტიკური ინსტრუმენტები, მათ შორის Google Analytics ან მსგავსი
              სერვისები, რათა გავიგოთ, როგორ გამოიყენება ჩვენი ვებსაიტი და სერვისები.
            </p>
            <p>
              ამ ინსტრუმენტების მიერ შეგროვებული ინფორმაცია გამოიყენება სერვისების გაუმჯობესების, წარმადობის
              შეფასებისა და მომხმარებლის გამოცდილების გასაუმჯობესებლად.
            </p>
          </section>

          <section>
            <h2>13. კალიფორნიის რეზიდენტების უფლებები</h2>
            <p>
              თუ თქვენზე ვრცელდება კალიფორნიის კონფიდენციალურობის კანონმდებლობა (CCPA/CPRA), შესაძლოა
              გქონდეთ დამატებითი უფლებები პერსონალურ მონაცემებთან დაკავშირებით.
            </p>
            <p>
              GFM Studio არ ყიდის მომხმარებელთა პერსონალურ მონაცემებს და არ იყენებს მათ ჯვარედინი კონტექსტის
              ქცევითი რეკლამისთვის, თუ სხვაგვარად პირდაპირ არ არის მითითებული.
            </p>
          </section>

          <section>
            <h2>14. ცვლილებები კონფიდენციალურობის პოლიტიკაში</h2>
            <p>ჩვენ შესაძლოა პერიოდულად განვაახლოთ ეს პოლიტიკა.</p>
            <p>
              ნებისმიერი ცვლილება გამოქვეყნდება ამ გვერდზე და განახლდება დოკუმენტის ზედა ნაწილში მითითებული
              &bdquo;ბოლოს განახლდა&ldquo; თარიღი.
            </p>
            <p>
              მნიშვნელოვანი ცვლილებების შემთხვევაში შესაძლოა დამატებით შეგატყობინოთ ელფოსტით, ვებსაიტის
              საშუალებით ან აპლიკაციის შიგნით.
            </p>
          </section>
        </div>
      ) : (
        <div className="privacy-content">
          <p className="privacy-lead">
            GFM Studio (&ldquo;we&rdquo;, &ldquo;our&rdquo;, or &ldquo;us&rdquo;) respects your privacy and is
            committed to protecting your personal information. This Privacy Policy explains how we collect, use,
            store, process, and protect information when you use our website, mobile applications, and related
            digital services (collectively, the &ldquo;Services&rdquo;).
          </p>
          <p>
            By accessing or using our Services, you acknowledge that you have read and understood this Privacy
            Policy.
          </p>

          <section>
            <h2>1. Who We Are</h2>
            <p>
              GFM Studio is a software development company that designs, develops, and maintains websites,
              mobile applications, and other digital products and services.
            </p>
            <p>For privacy-related inquiries, please contact us at:</p>
            <p>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>Depending on how you use our Services, we may collect and process the following categories of information:</p>

            <h3>Account and Profile Information</h3>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>User role or account status</li>
              <li>Information provided during registration or profile setup</li>
            </ul>

            <h3>Information You Provide</h3>
            <ul>
              <li>Contact form submissions</li>
              <li>Support requests</li>
              <li>Messages and communications</li>
              <li>Files, documents, and other content you upload or share through the Services</li>
            </ul>

            <h3>Device and System Information</h3>
            <ul>
              <li>Device type</li>
              <li>Operating system and version</li>
              <li>Browser type and version</li>
              <li>Application version</li>
              <li>Language settings</li>
              <li>IP address</li>
              <li>Diagnostic and technical logs</li>
            </ul>

            <h3>Usage Information</h3>
            <ul>
              <li>Features and functionality used</li>
              <li>Login and activity timestamps</li>
              <li>Interaction data</li>
              <li>Error reports and performance metrics</li>
            </ul>

            <h3>Communication Information</h3>
            <ul>
              <li>Correspondence with our support team</li>
              <li>Feedback, inquiries, and requests</li>
            </ul>

            <h3>Push Notifications</h3>
            <p>
              If you grant permission, we may store notification tokens to deliver service-related notifications.
              You can disable notifications at any time through your device settings.
            </p>

            <h3>Cookies and Similar Technologies</h3>
            <p>Our website may use cookies and similar technologies to:</p>
            <ul>
              <li>Maintain user sessions</li>
              <li>Remember preferences</li>
              <li>Improve security</li>
              <li>Analyze website traffic and performance</li>
            </ul>
            <p>You may manage or disable cookies through your browser settings.</p>
          </section>

          <section>
            <h2>3. How We Use Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>Provide, operate, and maintain our Services</li>
              <li>Authenticate users and manage access permissions</li>
              <li>Manage accounts and user profiles</li>
              <li>Provide customer support</li>
              <li>Improve functionality, performance, and user experience</li>
              <li>Monitor security and prevent fraud or abuse</li>
              <li>Send important service-related communications</li>
              <li>Comply with legal obligations</li>
              <li>Perform analytics and business reporting</li>
            </ul>
          </section>

          <section>
            <h2>4. Legal Bases for Processing</h2>
            <p>
              Where applicable under the General Data Protection Regulation (GDPR) or similar laws, we process
              personal data based on one or more of the following legal grounds:
            </p>
            <ul>
              <li><strong>Performance of a contract</strong> &ndash; to provide requested Services</li>
              <li><strong>Legitimate interests</strong> &ndash; to improve, secure, and support our Services</li>
              <li><strong>Legal obligations</strong> &ndash; to comply with applicable laws and regulations</li>
              <li><strong>Consent</strong> &ndash; where consent is required and obtained</li>
            </ul>
            <p>Where processing is based on consent, you may withdraw your consent at any time.</p>
          </section>

          <section>
            <h2>5. How We Share Information</h2>
            <p>We do not sell, rent, or trade personal information.</p>
            <p>We may share information with:</p>

            <h3>Service Providers</h3>
            <p>Third-party providers that assist us with:</p>
            <ul>
              <li>Hosting and infrastructure</li>
              <li>Cloud storage</li>
              <li>Email delivery</li>
              <li>Analytics</li>
              <li>Error monitoring</li>
              <li>Security and maintenance</li>
            </ul>
            <p>These providers process information only as necessary to perform services on our behalf.</p>

            <h3>Platform Providers</h3>
            <p>
              If you use our mobile applications, Apple and Google may process certain information according to
              their own privacy policies and platform requirements.
            </p>

            <h3>Legal and Regulatory Authorities</h3>
            <p>
              Where required by law, legal process, court order, or governmental request, or where necessary to
              protect rights, safety, security, or property.
            </p>

            <h3>Business Transfers</h3>
            <p>
              In connection with a merger, acquisition, reorganization, financing, or sale of company assets.
            </p>
          </section>

          <section>
            <h2>6. International Data Transfers</h2>
            <p>
              Your information may be processed and stored in Georgia, the European Economic Area (EEA), the
              United States, or other countries where we or our service providers operate.
            </p>
            <p>
              Where required by law, we implement appropriate safeguards for international data transfers,
              including Standard Contractual Clauses (SCCs) or equivalent legal mechanisms.
            </p>
          </section>

          <section>
            <h2>7. Data Retention</h2>
            <p>We retain personal information only for as long as necessary to:</p>
            <ul>
              <li>Provide our Services</li>
              <li>Fulfill legal obligations</li>
              <li>Meet accounting and regulatory requirements</li>
              <li>Resolve disputes</li>
              <li>Protect security and prevent abuse</li>
            </ul>
            <p>When information is no longer required, it is securely deleted or anonymized.</p>
          </section>

          <section>
            <h2>8. Security</h2>
            <p>We implement reasonable technical and organizational safeguards to protect personal information, including:</p>
            <ul>
              <li>Access controls</li>
              <li>Secure data storage practices</li>
              <li>System monitoring</li>
              <li>Security assessments and updates</li>
            </ul>
            <p>
              While we strive to protect your information, no method of electronic transmission or storage can
              be guaranteed to be completely secure.
            </p>
          </section>

          <section>
            <h2>9. Your Rights</h2>
            <p>Depending on your location and applicable law, you may have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Restrict or object to processing</li>
              <li>Request data portability</li>
              <li>Withdraw consent where applicable</li>
            </ul>
            <p>To exercise these rights, contact us at:</p>
            <p>
              <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>
            </p>
            <p>We may require identity verification before processing certain requests.</p>
          </section>

          <section>
            <h2>10. Children&apos;s Privacy</h2>
            <p>
              Our Services are not directed toward children under the age of 16, or the minimum age required by
              applicable law in your jurisdiction.
            </p>
            <p>
              We do not knowingly collect personal information from children. If you believe a child has provided
              personal information to us, please contact us so we can take appropriate action.
            </p>
          </section>

          <section>
            <h2>11. Third-Party Links and Services</h2>
            <p>
              Our Services may contain links to third-party websites, applications, or services.
            </p>
            <p>
              We are not responsible for the privacy practices of third parties and encourage you to review their
              privacy policies before providing any personal information.
            </p>
          </section>

          <section>
            <h2>12. Analytics</h2>
            <p>
              We may use analytics services, including Google Analytics or similar tools, to understand how users
              interact with our Services.
            </p>
            <p>
              Analytics information helps us improve functionality, performance, and overall user experience.
            </p>
          </section>

          <section>
            <h2>13. California Privacy Rights</h2>
            <p>
              If you are a California resident, you may have additional rights under the California Consumer
              Privacy Act (CCPA) and the California Privacy Rights Act (CPRA).
            </p>
            <p>
              GFM Studio does not sell personal information and does not share personal information for
              cross-context behavioral advertising unless otherwise disclosed.
            </p>
          </section>

          <section>
            <h2>14. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time.</p>
            <p>
              Any updates will be posted on this page, and the &ldquo;Last Updated&rdquo; date at the top of this
              document will be revised accordingly.
            </p>
            <p>
              For significant changes, we may also notify users through the Services, by email, or through other
              appropriate communication channels.
            </p>
          </section>
        </div>
      )}
    </div>
  );
};

export default Privacy;
